<template>

    <div class="col">
        <p class="step-caption ft-bld">Select the type of row you want to create</p>
        <SelectWrapper
            forced-one
            item="Automated row" 
            caption="Use a template to generate a row that displays a selection of content based on number of views, date added, score.." 
            :value="true"
            @input="rowTypeUpdate('auto')"
        ></SelectWrapper>
        <SelectWrapper
            forced-one
            item="Tag row" 
            caption="Generate a row by selecting one or multiple tags. Apply some rules to organize the order of content" 
            @input="rowTypeUpdate('tag')"
        ></SelectWrapper>
        <SelectWrapper
            forced-one
            item="Manual row" 
            caption="Create a row and manually select the content you want to add inside with the content search tool"
            @input="rowTypeUpdate('manual')"
        ></SelectWrapper>
        <div class="nxt-out">
            <!-- <div class="btn bck">
                <span class="txt">Back</span>
            </div> -->
            <div class="btn main txt-blk" @click.prevent="switchStep('nxt')">
                <span class="hvr"></span>
                <span class="txt">Continue</span>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import SelectWrapper from '../../components/SelectWrapper'

    export default {

        name: 'NewRowOne',

        components: {
            SelectWrapper
        },

        data() {
            return {
                Global,
            }
        },

        methods: {

            rowTypeUpdate(type) {
                this.$emit('rowType', type)
                this.Global.newRowOverlay.type = type
            },

            switchStep(dir) {
                this.$emit(dir)
            }

        }
    }

</script>